
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external/bb-visitor-sync",
      function () {
        return require("private-next-pages/external/bb-visitor-sync/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external/bb-visitor-sync"])
      });
    }
  